










































































































import { Component, Vue } from "vue-property-decorator";
import Ajax from '../../lib/ajax';
import User from "@/store/entities/user";
import Settings from "@/store/entities/settings";
@Component({
  components: { },
})

export default class GeneralSettings extends Vue {
  breadcrumbsItems: any[] = [];
  isValid: boolean = false;
  settings:Settings=new Settings()


  async saveSettings() {
  await Ajax.post(
        '/api/services/app/Admin/ChangePageSetting',this.settings
      );

      Vue.$toast.success("Ayarlar Güncellendi");
   
  }

  
  async created() {

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Genel Ayarlar", disabled: true },
    ];
    await this.getSettings();
  }
  async getSettings(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetPageSetting'
      );
      var data = response.data.result;
      this.settings=data;
  }





}
